const accessTokenKey = 'KI_token'

export const saveAccessToken = (accessToken: string) => {
    localStorage.setItem(accessTokenKey, accessToken)
}

export const getAccessToken = () => {
    return localStorage.getItem(accessTokenKey) || null
}

export const removeAccessToken = () => {
    localStorage.removeItem(accessTokenKey)
}
